import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-three',
  templateUrl: './review-three.component.html',
  styleUrls: ['./review-three.component.css']
})
export class ReviewThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
